import './App.css';
import React from 'react';
import { useEffect, useState, useRef, useContext } from 'react';
import { Routes, Route, Link, useNavigate, useLocation, Outlet, json } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { useSpring, animated, a } from '@react-spring/web'
import { useInView } from 'react-intersection-observer';
import { v4 as uuidv4 } from 'uuid';
import ReactGA from "react-ga4";

import { Setlib } from './store.js';
import { Static, ShowLoading, ShowToast, ImgGet, ImgGetHas, GetPFImgClass } from './util.js';
import { Adsense } from './ads.js';
import { User } from './user.js';
import { User as UserModal } from './user.js';

import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';

import ImgLogo from './img/Logo.webp';
import ImgTitle from './img/Title.png';
import ImgNullSlot from './img/NoImg.png';
import ImgVs from './img/vs.png';
import ImgTuto1 from './img/Tuto1.webp';
import ImgTuto2 from './img/Tuto2.webp';
import ImgTuto3 from './img/Tuto3.webp';


import './Bs.css';


function Main() {

    const store = useSelector((state) => state);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    let [libgame, libgameSet] = useState([]);

    let [imgqz, imgqzSet] = useState({});

    let [loading, loadingSet] = useState(false);
    let [more, moreSet] = useState(true);
    const [moreRef, moreInView] = useInView();
    const moreNum = useRef(0);

    let subtxt0 = { txt: '베스트 커플 찾기', col: 'red', step: 0 };
    let subtxt1 = { txt: '친구들과 궁합 보기', col: 'blue', step: 1 };
    let subtxt2 = { txt: '상대 취향 알아보기', col: 'green', step: 2 };

    const [aniSubTxt0, aniSubTxt0Api] = useSpring(() => ({
        from: {
            y: -30,
            height: 0,
            opacity: 0
        },
    }))
    const [aniSubTxt1, aniSubTxt1Api] = useSpring(() => ({
        from: {
            y: 0,
            height: 30,
            opacity: 1
        },
    }))
    const [aniSubTxt2, aniSubTxt2Api] = useSpring(() => ({
        from: {
            y: 30,
            height: 0,
            opacity: 0
        },
    }))


    useEffect(() => {


        let subtex = [subtxt0, subtxt1, subtxt2];
        let roll = [aniSubTxt0Api, aniSubTxt1Api, aniSubTxt2Api];
        setInterval(() => {

            subtex.map((d, i) => {

                if (d.step == 0) {
                    roll[i].start({
                        from: {
                            y: -30,
                            height: 0,
                            opacity: 0
                        },
                        to: {
                            y: 0,
                            height: 30,
                            opacity: 1
                        },
                        config: { duration: 500 },
                    })
                }
                if (d.step == 1) {
                    roll[i].start({
                        from: {
                            y: 0,
                            height: 30,
                            opacity: 1
                        },
                        to: {
                            y: 30,
                            height: 0,
                            opacity: 0
                        },
                        config: { duration: 500 },
                    })
                }
                if (d.step == 2) {
                    roll[i].start({
                        from: {
                            y: 0,
                            height: 0,
                            opacity: 0
                        },
                        to: {
                            y: -30,
                            height: 0,
                            opacity: 0
                        },
                        config: { duration: 500 },
                    })
                }

                d.step++;

                if (d.step == 3) d.step = 0;

            })

        }, 2000);


    }, [])


    useEffect(() => {

        if (!more) {
            return;
        }

        if (process.env.NODE_ENV === 'development') {
            console.log(moreInView, '무한 스크롤 요청 🎃')
        }

        loadingSet(true);

        moreSet(false);


        axios.post(Static.SvrAddr + 'gettopgame', {
            num: moreNum.current,
        }).then((res) => {
            console.log(moreNum.current);
            console.log(res);


            res.data[1].map((d, i) => {

                d.qz = typeof d.qz === 'string' ? JSON.parse(d.qz) : d.qz;

                d.qz.map((dq, iq) => {

                    if (dq[3] == '@') {
                        dq[3] = d.uid + '_' + iq;
                    }
                    if (dq[4] == '@') {
                        dq[4] = d.uid + '_' + iq;
                    }

                    if (iq == 0) {
                        LoadImg(true, dq[3], 'A');
                        LoadImg(true, dq[4], 'B');
                    }
                });
            });

            let slot = { title: res.data[0][0].title, game: res.data[1] };
            console.log(slot);
            libgameSet((d) => [...d, slot]);

            moreNum.current++;

            moreSet(res.data[0][0].more);

            loadingSet(false);

        }).catch((err) => {
            console.log('gettopgame failed:', err?.message);
            console.log('Response status:', err?.response?.status);
            console.log('Response data:', err?.response?.data);
            loadingSet(false);
            moreSet(true);
        })

    }, [moreInView]);


    async function LoadImg(lib, key, slot) {

        let dir = lib ? 'lib/' : 'qz/';

        if (key != 'N') {

            let file = key + '-' + slot;
            console.log(file);
            ImgGet(Static.SvrAddr, dir + file).then(res => {
                imgqzSet(old => ({ ...old, [file]: res }))
            });
        }
    }

    function GetImgSrc(key) {

        if (imgqz.hasOwnProperty(key)) {

            return imgqz[key];
        }

        return ImgNullSlot;
    }



    function ContextAwareToggle({ children, eventKey, callback }) {
        const { activeEventKey } = useContext(AccordionContext);

        const isCurrentEventKey = activeEventKey == eventKey;

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(isCurrentEventKey),
        );

        return (
            <button
                className={"px-2 collapsed p-2 border border-1 rounded-4 " + (isCurrentEventKey ? 'bg-primary' : 'bg-white')}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseThree"

                onClick={decoratedOnClick}
            >
                {children} <i class={isCurrentEventKey ? 'fi-rr-angle-up va-m' : 'fi-rr-angle-down va-m'}></i>
            </button>
        );
    }


    function LibSlot(gi, qz, qi) {

        let imgslot = qz.qz[qi][3] != 'N' || qz.qz[qi][4] != 'N';
        let slotclass = imgslot ? 'd-flex align-items-start' : 'd-flex align-items-center';

        return (

            <div className={qi == 1 ? 'd-flex flex-column p-2 border-top' : 'd-flex flex-column p-2'}>

                {qz.qz[qi][0] != '' && (
                    <div className='my-3'>
                        {qz.qz[qi][0]}
                    </div>
                )}

                <div className={slotclass}>

                    <div className='d-flex flex-column col'>
                        {imgslot ? (
                            <>
                                <img className='rounded-2' src={GetImgSrc(qz.qz[qi][3] + '-A')}
                                    style={{
                                        objectFit: 'cover',
                                        aspectRatio: 5 / 3,
                                        width: '100%'
                                    }}
                                    alt={qz.qz[qi][1]}
                                ></img>
                                {qz.qz[qi][1]}
                            </>
                        ) : (
                            <div className='fs-5 d-flex justify-content-center align-items-center' style={{
                                aspectRatio: 3 / 1,
                                width: '100%',
                            }}>
                                {qz.qz[qi][1]}
                            </div>
                        )}
                    </div>

                    <div className='align-self-center'>
                        <img className='' src={ImgVs} style={{ height: '40px', width: '40px' }} alt='VS' />
                    </div>

                    <div className='d-flex flex-column col'>
                        {imgslot ? (
                            <>
                                <img className='rounded-2' src={GetImgSrc(qz.qz[qi][4] + '-B')}
                                    style={{
                                        objectFit: 'cover',
                                        aspectRatio: 5 / 3,
                                        width: '100%'
                                    }}
                                    alt={qz.qz[qi][2]}
                                ></img>
                                {qz.qz[qi][2]}
                            </>
                        ) : (
                            <div className='fs-5 d-flex justify-content-center align-items-center' style={{
                                aspectRatio: 3 / 1,
                                width: '100%',
                            }}>
                                {qz.qz[qi][2]}
                            </div>
                        )}

                    </div>
                </div>
            </div>
        )
    }


    async function Push(game, d, i) {

        return new Promise(async (res) => {
            let qid = game.uid + '_' + i;

            const [imgA, imgB] = await Promise.all([LoadImgLib(d[3] + '-A'), LoadImgLib(d[4] + '-B')]);

            let qz = {
                gid: game.uid,
                qid: qid,
                qz: game.qz[i],
                img: [imgA, imgB],
                sid: uuidv4()
            }

            res(qz);
        });
    }


    async function LoadImgLib(key) {

        return new Promise((resp) => {
            if (key == 'N') {
                resp(null);
            }
            else {
                if (imgqz.hasOwnProperty(key)) {
                    resp(imgqz[key]);
                }
                else {
                    ImgGet(Static.SvrAddr, 'lib/' + key).then(res => {
                        resp(res);
                    });
                }
            }
        });
    }


    async function LibSelect(game, idx) {

        let create = JSON.parse(sessionStorage.getItem('create'));
        console.log(create);
        if (create == null) {
            create = { title: game.title, qzList: [] };
        }
        else {
            if (window.confirm('작성중인 문제들이 있어요. 지우고 이 게임을 만들까요?')) {
                create.title = game.title;
                create.qzList = [];
            }
            else {
                return;
            }
        }

        const pl = game.qz.map(async (d, i) => {
            return await Push(game, d, i);
        });

        const qz = await Promise.all(pl);

        for (let i = 0; i < qz.length; i++) {
            create.qzList.push(qz[i]);
        }

        sessionStorage.setItem('lib', JSON.stringify(create));

        navigate('/create');

        ReactGA.event('click_thisgame', { '알고리즘페이즈': idx });
    }

    return (
        <div className='text-center'>

            {/* <DisplayAds /> */}
            <div className='text-center'>

                <div className='d-flex align-items-center justify-content-center rounded-5' style={{
                    width: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                    backgroundImage: `url(${ImgLogo})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '400px',
                }}>
                    <div className='d-flex align-items-center justify-content-center' style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                    }}>
                        <div className='text-white flex-fill'>
                            <div className='d-flex flex-wrap justify-content-center align-items-center' style={{ backgroundColor: '', height: 50 }}>
                                <div className='col text-end'>
                                    <h1 className='fs-5'><b>밸런스 게임</b>으로</h1>
                                </div>

                                <div className='col justify-content-start text-start align-items-center ms-2' style={{}}>
                                    <animated.div className='text-primary bg-black bg-opacity-50' style={{ overflow: 'hidden', position: 'absolute', transform: 'translate(0%, -50%)', ...aniSubTxt0 }}>
                                        <h2 className='fs-5'><b>{subtxt0.txt}</b></h2>
                                    </animated.div>
                                    <animated.div className='text-success bg-black bg-opacity-50' style={{ overflow: 'hidden', position: 'absolute', transform: 'translate(0%, -50%)', ...aniSubTxt1 }}>
                                        <h2 className='fs-5'><b>{subtxt1.txt}</b></h2>
                                    </animated.div>
                                    <animated.div className='text-warning bg-black bg-opacity-50' style={{ overflow: 'hidden', position: 'absolute', transform: 'translate(0%, -50%)', ...aniSubTxt2 }}>
                                        <h2 className='fs-5'><b>{subtxt2.txt}</b></h2>
                                    </animated.div>
                                </div>
                            </div>
                            <img className='' src={ImgTitle} style={{ height: '150px' }} alt='밸런스게임으로 보는 궁합 - 밸궁 텍스트 로고'></img>
                        </div>
                    </div>

                </div>

                {/* <div>
                    <Button className='rounded-pill border-0 m-2 p-3 px-4' onClick={() => {
                        navigate('/create');
                        ReactGA.event('click_main_create_btn');
                    }}>
                        <i class="fi-rr-plus va-m"></i> 새 게임 만들기 </Button>
                </div> */}

            </div>




            <div className='my-4'>
                <Adsense type='dp' />
            </div>


            {User('all', 'lib')}


            <Modal show={store.lib.modal} fullscreen={true} onHide={() => dispatch(Setlib(false))} backdrop={true}>
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-0">
                    <div className='width-sm margin-auto'>
                        {UserModal(store.lib.uuid, 'libmodal')}
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    )
}


export default Main;
